import isString from './isString.js';

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {

	/**
	 * Generate route link with all query parameters in current route
	 * @param {string} name Route name
	 * @param {object} [query] Additional query parameters
	 * @returns {string} Generated route path
	 */
	Vue.prototype.getLink = function(name, query = {}) {
		return this.$router.resolve({
			name,
			query: query ? Object.entries({
				...this.$route.query,
				...query
			}).reduce((previous, [key, value]) => {
				if (isString(value, 1)) {
					previous[key] = value;
				}
				return previous;
			}, {}) : null
		}).href;
	};
};

export default {
	install
};
